import React, { FunctionComponent, useMemo } from "react";
import { ViewerContext, ViewerContextShape } from "./ViewerContext";

const ViewerProvider: FunctionComponent<ViewerContextShape> = ({
  children,
  viewer,
  bookData,
}) => {
  const value = useMemo(() => ({ viewer, bookData }), [viewer, bookData]);

  return (
    <ViewerContext.Provider value={value}>{children}</ViewerContext.Provider>
  );
};

export default ViewerProvider;
